export interface CategoryConfidence {
  offense_confidence?: string;
  formation_confidence?: string;
  coverage_confidence?: string;
  pressure_confidence?: string;
  situational_confidence?: string;
  overall_confidence?: string;
}

export const CUSTOMER_DISCLAIMER =
  'Findings are based on a representative sample of gameplay from this video. Review evidence timestamps to validate key tendencies.';

export type CustomerConfidenceLabel = 'High' | 'Moderate' | 'Medium' | 'Limited';

/** Map backend tier labels to customer-facing copy (Low → Limited). */
export function customerConfidenceLabel(
  value: string | undefined | null
): CustomerConfidenceLabel | null {
  if (!value) return null;
  const normalized = value.trim();
  if (normalized === 'Low') return 'Limited';
  if (normalized === 'Limited') return 'Limited';
  if (normalized === 'Moderate') return 'Moderate';
  if (normalized === 'Medium') return 'Medium';
  if (normalized === 'High') return 'High';
  return null;
}

export const CATEGORY_CONFIDENCE_ROWS: {
  key: keyof CategoryConfidence;
  label: string;
}[] = [
  { key: 'offense_confidence', label: 'Run/Pass Identity' },
  { key: 'formation_confidence', label: 'Formations' },
  { key: 'coverage_confidence', label: 'Coverage' },
  { key: 'pressure_confidence', label: 'Pressure' },
  { key: 'situational_confidence', label: 'Situational' },
];
